export default __webpack_public_path__ + "static/media/wTop_1_c1.4083c70f.jpeg";